var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-breadcrumb", {
    staticClass: "flex-sub bread-wrapper",
    attrs: {
      separator: "/"
    }
  }, _vm._l(_vm.breadList, function (item, index) {
    return _c("a-breadcrumb-item", {
      key: item.path
    }, [index == 0 && _vm.breadList.length > 1 ? _c("router-link", {
      attrs: {
        to: item.path
      }
    }, [_vm._v(_vm._s(_vm.$t(item.meta.title)))]) : _c("span", [_vm._v(_vm._s(_vm.$t(item.meta.title)))])], 1);
  }), 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };